export const AMPM = ["AM", "PM"];

export const DEFAULT_START_WORKING_HOUR: AppointmentBookingTime = {
  hour: "09",
  minute: "00",
};

export const DEFAULT_END_WORKING_HOUR: AppointmentBookingTime = {
  hour: "17",
  minute: "00",
};
